// extracted by mini-css-extract-plugin
export var container = "_nq-0";
export var dotAnimation = "_nq-2";
export var dotsLoading = "_nq-1";